import { render, staticRenderFns } from "./add_vtwd.vue?vue&type=template&id=6e77a7ea&scoped=true"
import script from "./add_vtwd.vue?vue&type=script&lang=js"
export * from "./add_vtwd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e77a7ea",
  null
  
)

export default component.exports